import { autoinject } from 'aurelia-framework';

import { GenericApi } from '~/api/generic-api';
import { UserModel } from '~/api/user-service';
import { FetchUtils } from '~/utils/fetch-utils';

@autoinject
export class UserApi extends GenericApi {
	/**
	 * fetch user information, all fields of ModifiedByUserModel are not undefined or null
	 * @param userId user id
	 */
	public getUserModel(userId: number | string): Promise<UserModel> {
		const url = GenericApi.apiServerURL + 'api/users/' + userId;
		return FetchUtils.getJSON<UserModel>(url);
	}
}
